import { gql } from "@apollo/client";

export const createLensSpaceLens = gql`
    mutation createLensSpaceLens(
        $submissionId: ID!
        $lensId: ID
        $lensName: String!
        $tagsList: [String!]!
        $visibility: Visibility!
        $lensCta: MyLensesLensCtaInput
        $lensSpaceId: ID!
        $digitalGoodsList: [DigitalGoodInput!]!
        $discoverability: DiscoverabilityInput!
        $lensCreatorPayoutEnrolled: Boolean!
        $description: String!
        $releaseNote: String
        $previewMediaResources: [PreviewMediaResource!]
        $spectaclesTagsList: [String!]!
        $isMarkedExclusive: Boolean!
        $isGameUserProvided: Boolean!
    ) {
        createMyLensesLensSpaceLens(
            input: {
                submissionId: $submissionId
                lensId: $lensId
                lensName: $lensName
                tagsList: $tagsList
                visibility: $visibility
                lensCta: $lensCta
                lensSpaceId: $lensSpaceId
                digitalGoodsList: $digitalGoodsList
                discoverability: $discoverability
                lensCreatorPayoutEnrolled: $lensCreatorPayoutEnrolled
                description: $description
                releaseNote: $releaseNote
                previewMediaResources: $previewMediaResources
                spectaclesTags: $spectaclesTagsList
                isMarkedExclusive: $isMarkedExclusive
                isGameUserProvided: $isGameUserProvided
            }
        ) {
            lens {
                id
                name
            }
        }
    }
`;
